/* eslint-disable @typescript-eslint/no-unsafe-return */
import { RedeemableTicketOptionsResponse } from '@givebacks/api/store';
import { Checkbox } from 'ui';

import { CheckInStatusColumn, TicketHolderNameColumn } from './columnComponents';
import { EventCheckInTableInstance } from './instance';
import { RedeemableTicketsRowActions } from './rowActions';

const eventCheckInColumns = [
  EventCheckInTableInstance.rowSelectionColumn({
    isRowVisuallyChecked: (row) => !!row.original.fulfilled_at,
  }),
  EventCheckInTableInstance.printColumn('fulfilled_at', {
    header: 'Status',
    // This is used to override the default id of the column so that we don't clash with the row selection column
    id: 'fulfilled',
    cell: ({ row }) => <Checkbox size="sm" checked={!!row.original.fulfilled_at} />,
  }),
  EventCheckInTableInstance.columnHelper.accessor('first_name', {
    header: 'Ticket Holder',
    cell: TicketHolderNameColumn,
    size: 200,
  }),
  EventCheckInTableInstance.columnHelper.accessor('uuid', {
    header: 'TicketID',
    cell: (props) => props.getValue(),
  }),
  EventCheckInTableInstance.columnHelper.accessor('cart_id', {
    header: 'Order No.',
    cell: (props) => props.getValue(),
  }),
  EventCheckInTableInstance.columnHelper.accessor('store_item.name', {
    header: 'Ticket Name',
    cell: (props) => props.getValue(),
  }),
  EventCheckInTableInstance.columnHelper.accessor('fulfilled_at', {
    header: 'Status',
    cell: CheckInStatusColumn,
    size: 125,
    meta: {
      isPrintable: false,
    },
  }),
  EventCheckInTableInstance.columnHelper.display({
    id: 'actions',
    size: 40,
    cell: RedeemableTicketsRowActions,
    meta: {
      isPrintable: false,
    },
  }),
];

const createDynamicColumns = (options: RedeemableTicketOptionsResponse['options']) => {
  return options
    .filter((option) => option.name)
    .map((option) => {
      return EventCheckInTableInstance.columnHelper.accessor(
        (row) => row.options?.[option.name] ?? '',
        {
          header: option.name,
          enableSorting: false,
        }
      );
    });
};

export { createDynamicColumns, eventCheckInColumns };
